import React from 'react';
// import { useSettings } from '../../contexts/SettingsContext';
import '../../styles/IconFix.css';

/**
 * PageTitle - A component to display consistent page titles with icons
 * 
 * @param {Object} props
 * @param {string} props.icon - The Font Awesome icon class (e.g., 'fa-tachometer-alt')
 * @param {string} props.title - The page title text
 * @param {React.ReactNode} props.action - Optional action button/element to display on the right
 * @param {string} props.className - Optional additional CSS classes
 */
const PageTitle = ({ icon, title, action, className = '' }) => {
  // No need to set CSS variables here since Settings.js handles this globally
  
  return (
    <div className="dashboard-header">
      <h1 className={`page-title ${className}`.trim()}>
        {icon && (
          <span className="page-icon-wrapper">
            <i className={`fas ${icon}`}></i>
          </span>
        )}
        {title}
      </h1>
      {action && (
        <div className="page-title-action">
          {action}
        </div>
      )}
    </div>
  );
};

export default PageTitle; 